// extracted by mini-css-extract-plugin
export default {"mCard":"HD-z","image":"ID-z","imageNoBackground":"JD-z","imageHasCategory":"KD-z","fullWidth":"LD-z"};